import { ConfirmationDialog } from '@/components/dialogs/confirmationDialog';

export const UnprotectSnapshotDialog = ({
  isOpen,
  onCancel,
  onConfirm,
}: {
  isOpen: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}) => {
  return (
    <ConfirmationDialog
      isOpen={isOpen}
      title='Remove hold'
      description='The snapshot won’t be available anymore because it’s past its expiration. Remove the hold only if you’re sure you don’t need the snapshot.'
      onCancel={onCancel}
      onConfirm={onConfirm}
      buttonTitle='Remove Hold'
      cancelButtonTitle='Keep Holding'
    />
  );
};
